<div class="ph-page-container bg-white-smoke mt-6 h-auto w-[79vw] flex flex-col ml-[12vw] pb-16 justify-center">

  <section *ngIf="!hideAdvancedFilters" class="neptune-advanced-filters">
    <advanced-filters
         [advancedFilterData]="advancedFilterDataOptions"
         [pageScope] = "'Program Hub Landing Page'"
         [selectedAdvancedFilters] = "selectedAdvancedFilters"
         [keyInputTypes] = "keyInputTypes"
         (selectedFilters) = "onSelectedFiltersChange($event)"
        ></advanced-filters>
  </section>
  <!-- Timeframe Dropdown Section-->
  <section class="timeframe-dropdown-container">
    <button type="button" class="dropdown-button" (click)="toggleDropdown()">
      <span>Timeframe: {{selectedPeriod}}</span>
      <span class="arrow" [ngClass]="{ down: !isOpen, up: isOpen }"></span>
    </button>
    <div class="dropdown-menu" *ngIf="isOpen">
      <button
        *ngFor="let option of options"
        (click)="selectOption(option)"
        class="dropdown-item"
        [class.selected]="option === selectedPeriod">
        {{option}}
      </button>
    </div>
  </section>

  <!-- Location Performance Section -->
  <section class="location-perf-container page-section" id="location-perf-section">
    <div class="title-row">
      <h3 class="section-title location">Location Performance</h3>
    </div>

      <div class="chart-row" *ngIf="!isLoading; else loadingTemplate">
        <ng-container *ngIf="hasData.locationPerformance; else noDataTemplate">
          <!-- Gauge Chart -->
          <div class="gauge-chart-container">
            <app-gauge-chart
              [needleValue]="gaugeNeedleValue"
              [chartLabel]="'Performance Rating'"
              [chartBottomText]="'*All Location Performance <br /> Rating'">
            </app-gauge-chart>
          </div>

          <!-- Performance Line Chart -->
          <div class="performance-rating-line-chart-container">
            <div class="pr-line-chart-title">Performance Rating</div>
            <div class="chart-wrapper">
              <app-line-graph-common-chart [config]="lineChartConfig" [unique_id]="'locations-overview'">
              </app-line-graph-common-chart>
            </div>
          </div>
        </ng-container>
      </div>
  </section>

  <!-- Observations Section -->
  <section class="observations-container page-section" id="observations-section">
    <div class="title-row">
      <h3 class="section-title observations">Observations</h3>
    </div>

    <div class="chart-row" *ngIf="!isLoading; else loadingTemplate">
      <!-- Number of Issues Comparison Bar Chart -->
      <div class="issues-comparison-chart">
        <div class="chart-title">
          {{comparisonChartTitle}}
        </div>

        <ng-container *ngIf="hasData.issuesComparison; else noComparisonChartData">
          <app-bar-chart
            [data]="comparisonChartData"
            [labels]="comparisonChartLabels"
            [barColor]="'#006BD3'"
            [unique_id]="'issues-comparison'"
            [chartName]="'PH-Issue Comparison'"
            [barChartConfig]="issuesComparisonChartConfig"
            [showLabelInTooltip]="true">
          </app-bar-chart>
        </ng-container>
        <ng-template #noComparisonChartData>
          <div class="no-data-block">
            <p>No data available</p>
          </div>
        </ng-template>
      </div>

      <!-- Total Issues Donut Chart -->
      <div class="total-issues-chart">
        <div class="chart-title">
          {{totalIssuesChartTitle}}
        </div>

        <ng-container *ngIf="hasData.totalIssues; else noIssuesChartData">
          <div class="donut-chart-container">
            <app-doughnut-chart
              [colors]="['#044EA0', '#99C4ED']"
              [data]="totalIssuesData"
              [customMiddleText]="totalIssuesMiddleText.toString()"
              [unique_id]="'total-issues'"
              [containerWidth]="170"
              [chartConfig]="donutChartConfig">
            </app-doughnut-chart>
          </div>

          <div class="legend-box">
            <div class="legend-item">
              <span class="color-box recurring"></span>
              <span class="legend-text">{{totalIssuesData[0]}}%&nbsp;&nbsp;Recurring Issues</span>
            </div>
            <div class="legend-item">
              <span class="color-box new"></span>
              <span class="legend-text">{{totalIssuesData[1]}}%&nbsp;&nbsp;New Issues</span>
            </div>
          </div>
        </ng-container>
        <ng-template #noIssuesChartData>
          <div class="no-data-block">
            <p *ngIf="hasNoLineChartData && !totalIssuesMiddleText" class="no-data-text">No data available</p>
            <p *ngIf="!hasNoLineChartData && !totalIssuesMiddleText" class="no-records-text">No records found for the selected period</p>
          </div>
        </ng-template>
      </div>

      <!-- Service Metrics Bar Chart -->
      <div class="service-metrics-chart">
        <div class="chart-title">
          {{serviceMetricsChartTitle}}
        </div>

        <ng-container *ngIf="hasData.serviceMetrics; else noSIChartData">
          <app-bar-chart
            [data]="serviceMetricsChartData"
            [labels]="serviceMetricsChartLabels"
            [barColor]="'#006BD3'"
            [yAxisLabel]="'Count of visits'"
            [chartName]="'PH-Service Metrics'"
            [unique_id]="'service-metrics'">
          </app-bar-chart>
        </ng-container>
        <ng-template #noSIChartData>
          <div class="no-data-block">
            <p class="no-records-text">No records found for the selected period</p>
          </div>
        </ng-template>
      </div>
    </div>
  </section> <!-- Observation section ends -->

  <!-- This Section is for Top Bottom Locations Program Hub -->
  <section id="top-bottom-locations" *ngIf="!isLoading; else loadingTemplate">
    <app-top-bottom-locations [selectedPeriod]="selectedPeriod" [locationData]="locationInsightsData"></app-top-bottom-locations>
  </section>

  <ng-template #loadingTemplate>
    <div class="loading-container">
      <loader size="medium"></loader>
      <p>Loading...</p>
    </div>
  </ng-template>

  <ng-template #noDataTemplate>
    <div class="no-data-container">
      <p>No data available</p>
    </div>
  </ng-template>

</div>
